module.exports = __webpack_public_path__ + "static/media/logo.f01839f4.svg";